import { NavLink } from 'react-router-dom';
import { useUnread } from '../state/unread';

/**
 * Chats / Mentions / Me — the three tabs build.txt asks for.
 *
 * Tap targets are 56px tall before the safe-area inset. This is used with wet
 * hands, in a hurry, sometimes wearing gloves; the Apple/Material 44-48px
 * minimum is a floor, not a target.
 */
export default function BottomNav() {
  const { totalUnread, totalMentions } = useUnread();

  return (
    <nav className="pb-safe shrink-0 border-t border-zinc-200 bg-surface/95 backdrop-blur">
      <div className="mx-auto flex max-w-lg">
        <Tab to="/" label="Chats" badge={totalUnread}>
          <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        </Tab>
        <Tab to="/mentions" label="Mentions" badge={totalMentions}>
          <circle cx="12" cy="12" r="4" />
          <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94" />
        </Tab>
        <Tab to="/me" label="Me">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </Tab>
      </div>
    </nav>
  );
}

function Tab({
  to,
  label,
  badge = 0,
  children,
}: {
  to: string;
  label: string;
  badge?: number;
  children: React.ReactNode;
}) {
  return (
    <NavLink
      to={to}
      end={to === '/'}
      className={({ isActive }) =>
        `relative flex flex-1 flex-col items-center justify-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
          isActive ? 'text-brand-accent' : 'text-zinc-400'
        }`
      }
    >
      <span className="relative">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-6 w-6"
          aria-hidden="true"
        >
          {children}
        </svg>
        {badge > 0 && (
          <span className="absolute -top-1.5 -right-2.5 min-w-[18px] rounded-full bg-red-500 px-1 text-[10px] leading-[18px] font-bold text-white">
            {badge > 99 ? '99+' : badge}
          </span>
        )}
      </span>
      {label}
    </NavLink>
  );
}
